import { render, staticRenderFns } from "./FeedbackEntranceCompnent.vue?vue&type=template&id=91578896&scoped=true"
import script from "./FeedbackEntranceCompnent.vue?vue&type=script&lang=ts"
export * from "./FeedbackEntranceCompnent.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackEntranceCompnent.vue?vue&type=style&index=0&id=91578896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91578896",
  null
  
)

export default component.exports